import { ChangeDetectorRef,Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgentDetailsModal } from 'projects/Administration/src/app/business-entities/agent-efficiency-model';
import { Filter } from 'projects/Administration/src/app/business-entities/Filter';
import { PagerData } from 'projects/Administration/src/app/business-entities/PagerData';
import { AgentEfficiencyService } from 'projects/Administration/src/app/business-services/agent-efficiency.service';
import { PaginationService } from 'projects/Administration/src/app/services/pagination.service';
import { NgbdSortableHeader } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { EntityType } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as Enums from '../../../../../../../Autofacets-Core/src/app/utils/enums';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-agents-details-list',
  templateUrl: './agents-details-list.component.html'
 
})
export class AgentsDetailsListComponent implements OnInit {
  agentDetailsList: AgentDetailsModal[];
  dealerList = [];
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;

  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  debounceTimer;
  heading:string = '';
  title:string = '';
  dataList: AgentDetailsModal[]=[];
  @Input() agentId;
  @Input() agentName;
  @Input() selectedDate;
  @Input() entityType;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private spinner: NgxSpinnerService,
    private activeModal: NgbActiveModal,
    private pagerService: PaginationService,
    private agentEfficiencyService:AgentEfficiencyService,
    private translate: TranslateService,
    private cdr:ChangeDetectorRef,
    private excelService: ExcelService,
    private toaster: ToastrService,
  ) { }

  ngOnInit() {
    this.GetHeadingAsPerEntity()
    this.agentEfficiencyService.agentDetailsRequestModel.startRecordNumber = 0;
    this.dealerList = this.agentEfficiencyService.dealerList;
    this.agentDetailsList = [];
    this.agentEfficiencyService.agentDetailsRequestModel.agentId = this.agentId;
    this.agentEfficiencyService.agentDetailsRequestModel.selectedDate = this.selectedDate;
    this.agentEfficiencyService.agentDetailsRequestModel.entityType = this.entityType
    this.getAgentDetailsList();
  }

  GetHeadingAsPerEntity(){
    switch(this.entityType){
      case EntityType.Appointment:{
        this.heading = this.translate.instant("lblAppointments");
        this.title = this.translate.instant("lblAppointmentDetails");
        break;
      }
      case EntityType.Customer:{
        this.heading = this.translate.instant("lblCustomers");
        this.title = this.translate.instant("lblCustomerDetails");
        break;
      }
      case EntityType.Vehicle:{
        this.heading = this.translate.instant("lblVehicles");
        this.title = this.translate.instant("lblVehicleDetails");
        break;
      }
      case EntityType.Call:{
        this.heading = this.translate.instant("lblCalls");
        this.title = this.translate.instant("lblCallDetails");
        break;
      }
    }
  }
 formatCallFromNo(callFromNo, dialCode) {
    if (!callFromNo) {
      return callFromNo;
    }
  
    if (callFromNo.charAt(0) === "+") {
      return callFromNo;
    } else {
      const formattedDialCode = dialCode ? dialCode : "47";
      return "+ " + formattedDialCode + " " + callFromNo;
    }
  }
  
  formatPhoneNumber(customerPhone, dialCode) {
    if (!customerPhone) {
      return customerPhone;
    }
  
    if (customerPhone.charAt(0) === "+") {
      return customerPhone;
    } else {
      const formattedDialCode = dialCode ? dialCode : "47";
      return "+ " + formattedDialCode + " " + customerPhone;
    }
  }

  async getAgentDetailsList() {
    this.spinner.show();
    await this.agentEfficiencyService
      .getAgentDetailsList(this.agentEfficiencyService.agentDetailsRequestModel)
      .then(
        (response) => {
          this.spinner.hide();
          this.agentDetailsList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            if(this.agentDetailsList?.length > 0){
              this.agentDetailsList?.forEach(x => {
                if(x?.bookedDate){
                  x.bookedDate = x.bookedDate ? new Date(x.bookedDate + 'Z') : null;
                }
                x.appointmentsCreatedModified = ((x?.appointmentsCreated)?x.appointmentsCreated:0).toString() + ' / ' +
                ((x?.appointmentsModified)?x.appointmentsModified:0).toString();
                x.customersCreatedModified = ((x?.customersCreated)?x.customersCreated:0).toString() + ' / ' +
                ((x?.customersModified)?x.customersModified:0).toString()
                x.vehiclesCreatedModified = ((x?.vehiclesCreated)?x.vehiclesCreated:0).toString() + ' / ' +
                ((x?.vehiclesModified)?x.vehiclesModified:0).toString()
                x.duration = Utility.toHoursAndMinutesAndSecond(x.totalDuration); // ((x?.totalDuration > 0) ? (x?.totalDuration/60) : 0).toFixed(2);
                x.callFromNo = this.formatCallFromNo(x.callFromNo, x.dialCode)
                x.customerPhone = this.formatPhoneNumber(x.customerPhone, x.dialCode)
                x.callHistoryId = x.callHistoryId ? x.callHistoryId : 0;
              })
            }
            this.totalCount =
              this.agentDetailsList.length > 0
                ? this.agentDetailsList[0].totalCount
                : 0;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.agentDetailsList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  loadMoreData(event){
    this.debounceFunction(()=>this.onScrollDown(event),200);
  }

  debounceFunction(func,delay){
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.agentDetailsList?.length) {
      this.agentEfficiencyService.agentDetailsRequestModel.startRecordNumber = this.agentDetailsList.length
      this.getAgentDetailsList();
    }
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }
  // Export functionality

  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.spinner.hide();
    this.excelService.exportAsExcelFile(excelData, this.title);
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const data = this.mapDataForExport();
    const doc = new jsPDF('landscape');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: data.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
    });
    doc.save(`${this.title}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.agentEfficiencyService.agentDetailsRequestModel.isExport = true;
    await this.agentEfficiencyService.getAgentDetailsList(this.agentEfficiencyService.agentDetailsRequestModel).then((res) => {
      if (!res || res.responseObject.length === 0) {
        this.toaster.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res.responseObject;
    }).finally(() => {
      this.agentEfficiencyService.agentDetailsRequestModel.isExport = false;
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => {
      switch (this.entityType) {
        case EntityType.Appointment:
          return {
            [this.translate.instant('lblNo')]: index + 1,
            [this.translate.instant('lblRegNumber')]: item.licensePlate,
            [this.translate.instant('lblWoNo')]: item.workOrderNo,
            [this.translate.instant('lblBookedDate')]: item.bookedDate,
            [this.translate.instant('lblWorkOrderStatus')]: item.workOrderStatus,
            [this.translate.instant('lblAction')]: item.action
          };
        case EntityType.Customer:
          return {
            [this.translate.instant('lblNo')]: index + 1,
            [this.translate.instant('lblCustomerNumber')]: item.customerNo,
            [this.translate.instant('lblCustomerName')]: item.customerName,
            [this.translate.instant('lblCustomerPhone')]: item.customerPhone,
            [this.translate.instant('lblCustomerEmail')]: item.customerEmail,
            [this.translate.instant('lblAction')]: item.action
          };
        case EntityType.Vehicle:
          return {
            [this.translate.instant('lblNo')]: index + 1,
            [this.translate.instant('lblRegNumber')]: item.licensePlate,
            [this.translate.instant('lblVinNumber')]: item.chassisNo,
            [this.translate.instant('lblVehicleGroup')]: item.vehicleGroup,
            [this.translate.instant('lblVehicleType')]: item.vehicleType,
            [this.translate.instant('lblFuelType')]: item.fuelType,
            [this.translate.instant('lblAction')]: item.action
          };
        case EntityType.Call:
          return {
            [this.translate.instant('lblNo')]: index + 1,
            [this.translate.instant('lblCustomerName')]: item.customerName,
            [this.translate.instant('lblCallFromNo')]: this.formatCallFromNo(item.callFromNo, item.dialCode),
            [this.translate.instant('lblTotalCallDuration')]: Utility.toHoursAndMinutesAndSecond(item.totalDuration),
            [this.translate.instant('lblStartTime')]: item.callStartTime,
            [this.translate.instant('lblEndTime')]: item.callEndTime,
          };
        default:
          return {};
      }
    });
  }

  private getHeadersForExport(): string[] {
    switch (this.entityType) {
      case EntityType.Appointment:
        return [
          this.translate.instant('lblNo'),
          this.translate.instant('lblRegNumber'),
          this.translate.instant('lblWoNo'),
          this.translate.instant('lblBookedDate'),
          this.translate.instant('lblWorkOrderStatus'),
          this.translate.instant('lblAction')
        ];
      case EntityType.Customer:
        return [
          this.translate.instant('lblNo'),
          this.translate.instant('lblCustomerNumber'),
          this.translate.instant('lblCustomerName'),
          this.translate.instant('lblCustomerPhone'),
          this.translate.instant('lblCustomerEmail'),
          this.translate.instant('lblAction')
        ];
      case EntityType.Vehicle:
        return [
          this.translate.instant('lblNo'),
          this.translate.instant('lblRegNumber'),
          this.translate.instant('lblVinNumber'),
          this.translate.instant('lblVehicleGroup'),
          this.translate.instant('lblVehicleType'),
          this.translate.instant('lblFuelType'),
          this.translate.instant('lblAction')
        ];
      case EntityType.Call:
        return [
          this.translate.instant('lblNo'),
          this.translate.instant('lblCustomerName'),
          this.translate.instant('lblCallFromNo'),
          this.translate.instant('lblTotalCallDuration'),
          this.translate.instant('lblStartTime'),
          this.translate.instant('lblEndTime'),
        ];
      default:
        return [];
    }
  }
}